// Generated by ReScript, PLEASE EDIT WITH CARE


function getConfig(chain, web3Context) {
  var match = chain !== 1 ? [
      "ETH",
      "mainnet"
    ] : [
      "DAI",
      "matic"
    ];
  var match$1 = web3Context.chainId;
  var match$2 = match$1 === 1 ? [
      "PRODUCTION",
      "03e872c1-35c8-436a-8577-134c87912956"
    ] : [
      "STAGING",
      "95d4e321-7e4e-4a87-92ea-7daac496de7e"
    ];
  return {
          environment: match$2[0],
          apiKey: match$2[1],
          hostURL: window.location.origin,
          cryptoCurrencyCode: undefined,
          defaultCryptoCurrency: match[0],
          cryptoCurrencyList: undefined,
          networks: undefined,
          walletAddress: web3Context.account,
          walletAddressesData: undefined,
          fiatCurrency: undefined,
          countryCode: undefined,
          fiatAmount: undefined,
          defaultNetwork: match[1],
          defaultFiatAmount: undefined,
          paymentMethod: undefined,
          defaultPaymentMethod: undefined,
          disablePaymentMethods: undefined,
          email: undefined,
          userData: undefined,
          partnerOrderId: undefined,
          partnerCustomerId: undefined,
          accessToken: undefined,
          redirectURL: undefined,
          disableWalletAddressForm: undefined,
          isAutoFillUserData: undefined,
          themeColor: "#6BAD3E",
          height: undefined,
          width: undefined,
          hideMenu: undefined,
          hideExchangeScreen: undefined,
          isDisableCrypto: true,
          isFeeCalculationHidden: undefined,
          exchangeScreenTitle: "Top up your balance for Wildcards"
        };
}

export {
  getConfig ,
  
}
/* No side effect */
